import { getFeaturePanelDefinition } from "../feature-panel-registry.ts";
import type { RuntimeFeatureModule } from "../runtime-feature-registry.ts";
import {
  applyColorEffectValue,
  resetColorEffectValue,
} from "../shared/page-color-effects.ts";
import {
  createRangeControl,
  formatNumber,
  normalizeSteppedValue,
  parseNumericConfig,
} from "../shared/feature-value.ts";

const variable = "--migrosone-a11y-grayscale-filter";
const attribute = "data-migrosone-a11y-grayscale";
const fallback = {
  defaultValue: 0,
  min: 0,
  max: 100,
  step: 10,
};

function getConfig(config: unknown) {
  return parseNumericConfig({
    config,
    defaultKeys: ["intensity", "grayscale", "saturationReduction"],
    fallback,
  });
}

function createFilterValue(intensity: number) {
  return intensity > 0 ? `grayscale(${formatNumber(intensity)}%)` : "";
}

const definition = getFeaturePanelDefinition("grayscale");

if (!definition) {
  throw new Error("Missing grayscale feature definition");
}

export const grayscaleFeatureModule: RuntimeFeatureModule = {
  key: "grayscale",
  definition,
  isSupported({ document }) {
    return Boolean(document.head && document.body && document.documentElement);
  },
  renderControl({ config, document, onPreferenceChange, preference }) {
    return createRangeControl({
      config: getConfig(config),
      document,
      label: "Gri ton",
      onPreferenceChange,
      preference,
      suffix: "%",
    });
  },
  apply({ config, document, preference }) {
    const numericConfig = getConfig(config);
    const value = normalizeSteppedValue(preference, numericConfig);
    const filterValue = createFilterValue(value);
    if (!filterValue) {
      resetColorEffectValue({ attribute, document, variable });
      return;
    }

    applyColorEffectValue({
      attribute,
      document,
      value: filterValue,
      variable,
    });
  },
  reset({ config, document }) {
    resetColorEffectValue({ attribute, document, variable });
    const numericConfig = getConfig(config);
    const filterValue = createFilterValue(numericConfig.defaultValue);
    if (filterValue) {
      applyColorEffectValue({
        attribute,
        document,
        value: filterValue,
        variable,
      });
    }
  },
};
